import { get, useFormContext } from "react-hook-form";

const Error = ({ name }) => {
  const {
    formState: { errors },
  } = useFormContext();

  const error = get(errors, name);

  if (!error) return null;

  return <span style={{ color: "#ff4d4f", fontSize: "12px", marginTop: 4 }}>{error.message}</span>;
};

export default Error;
